import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import PlacesInput from './components/PlacesInput';

const getColor = distance => {
  if (!distance) return '#92f0f0';
  if (distance < 25000) return '#89efb8'
  return '#f2b0d8'
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: ${({ distance }) => getColor(distance)};
  min-height: 100vh;
  color: #444;
  font-size: 2rem;
  font-weight: 300;
  overflow: hidden;
`

const Option = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 0;
  max-width: 100vw;
`

const Text = styled.span`
  margin: 0 1rem;

  @media screen and (min-device-width: 768px) {
    margin: 0;
  }
`

const Answer = styled.p`
  font-weight: 400;
font-size: ${props => props.small ? '3rem' : '4rem' };
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin-bottom: 0.5rem;
  text-align: center;
`

const App = () => {
  const [origin, setOrigin] = useState()
  const [destination, setDestination] = useState()
  const [distance, setDistance] = useState()

  useEffect(() => {
    origin && destination
      ? setDistance(window.distanceFrom(origin, destination))
      : setDistance()
  }, [origin, destination])

  return (
    <Container distance={distance}>
      <Option>
        <Text>I live here</Text>
        <PlacesInput focus={true} setGeolocation={setOrigin} placeholder="Parliament House" />
      </Option>
      <Option>
        <Text>Can I go here </Text>
        <PlacesInput setGeolocation={setDestination} placeholder="McDonald's" />
      </Option>
      {distance === 0 ? <Answer small>🏡 Good idea 🏡</Answer> : null}
      {distance && distance !== 0 ? <Answer>{distance < 25000 ? '😎 Yes 😎' : '😷 No 😷'}</Answer> : null}
    </Container>
  );
}

export default App;
